import type { UserEnvWithOptionalBranch } from '@shared/models/user-env/user-env-with-optional-branch.model';

/** Build `company` / `working_period` / `branch` / `warehouse` from `sessionStorage.userEnv`. */
export function readUserEnvContext(): UserEnvWithOptionalBranch {
  try {
    const raw = sessionStorage.getItem('userEnv');
    const userEnv = raw ? JSON.parse(raw) : {};
    return {
      company: userEnv?.company ?? null,
      working_period: userEnv?.working_period ?? null,
      branch: userEnv?.branch ?? null,
      warehouse: userEnv?.warehouse ?? null,
    };
  } catch {
    return { company: null, working_period: null };
  }
}

export function readCompanyId(): string | number | null {
  const c = readUserEnvContext().company as { id?: string | number } | null;
  return c?.id ?? null;
}

export function readWorkingPeriodId(): string | number | null {
  const w = readUserEnvContext().working_period as { id?: string | number } | null;
  return w?.id ?? null;
}

/** Grid filter shape: only ids, not full session objects. */
export function readUserEnvIds(): {
  company: { id: string | number | null };
  working_period: { id: string | number | null };
} {
  return {
    company: { id: readCompanyId() },
    working_period: { id: readWorkingPeriodId() },
  };
}
